<div class="hero-text-with-link">
  <p>{{ url }}</p>
  <div class="hero-text-action"
    (click)="onClick()">
    <rmx-icon name="external-link-line"></rmx-icon>
  </div>
</div>
